import type { Kysely } from 'kysely';
import type { InsightsMart } from './internal/db-types.generated.ts';

export type InsightType =
    | 'ChurnWarningWebCategory'
    | 'FirstPurchaseWebCat3'
    | 'GlobalChurnWarning'
    | 'GlobalTopCategory'
    | 'IndustryTopCategory'
    | 'PreviouslyPurchasedCategory'
    | 'ShareOfWalletCategory'
    | 'XSellWebCategory';

export const opportunityInsightTypes = Object.freeze([
    'FirstPurchaseWebCat3',
    'GlobalTopCategory',
    'IndustryTopCategory',
    'PreviouslyPurchasedCategory',
    'ShareOfWalletCategory',
    'XSellWebCategory',
] satisfies InsightType[]);

// A customer can carry both a category and a global churn warning, so risk sums built from this
// list can count the same decline twice. Accepted for now (~5% overlap on staging); dedup is
// pipeline-side (RETAIN-804).
export const riskInsightTypes = Object.freeze([
    'ChurnWarningWebCategory',
    'GlobalChurnWarning',
] satisfies InsightType[]);

export type OpportunityInsightType = (typeof opportunityInsightTypes)[number];

export const brandPreferenceGroupingInsightTypes = Object.freeze([
    'FirstPurchaseWebCat3',
    'ShareOfWalletCategory',
    'XSellWebCategory',
] satisfies InsightType[]);

export type InsightVersion = `v${number}`;
export type InsightVersionSelection = Partial<Record<InsightType, InsightVersion>>;

export type InsightsContext = {
    config: InsightsConfig;
    starrocks: Kysely<InsightsMart>;
};

export type InsightsConfig = {
    insightVersionSelection: InsightVersionSelection;
};
